"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSpellEffectHelper = void 0;
var common_1 = require("@timeflies/common");
var tilemap_utils_1 = require("@timeflies/tilemap-utils");
var compute_action_area_1 = require("./compute-action-area");
var createSpellEffectHelper = function (params) {
    var context = params.context, spellAction = params.partialSpellAction;
    var currentTurn = context.currentTurn, staticState = context.staticState, state = context.state, map = context.map;
    var _actionArea;
    var getActionArea = function () {
        if (!_actionArea) {
            _actionArea = compute_action_area_1.computeActionArea(params);
        }
        return _actionArea;
    };
    var getLauncher = function () { return getCharacterById(currentTurn.characterId); };
    var getCharacterTeamColor = function (characterId) { return staticState.players[staticState.characters[characterId].playerId].teamColor; };
    var getCharacterById = function (characterId) { return (__assign(__assign(__assign({}, staticState.characters[characterId]), common_1.ObjectTyped.entries(state.characters)
        .reduce(function (acc, _a) {
        var _b = __read(_a, 2), variableName = _b[0], variableMap = _b[1];
        acc[variableName] = variableMap[characterId];
        return acc;
    }, {})), { getRelation: function () { return characterId === currentTurn.characterId
            ? 'me'
            : getCharacterTeamColor(characterId) === getCharacterTeamColor(currentTurn.characterId)
                ? 'ally' : 'enemy'; } })); };
    var isPositionOccupied = function (position) { return Object.values(state.characters.position).some(function (characterPosition) { return characterPosition.id === position.id; }); };
    var getHitCharacters = function () {
        var actionArea = getActionArea();
        return Object.entries(state.characters.position)
            .filter(function (_a) {
            var _b = __read(_a, 2), characterId = _b[0], position = _b[1];
            return actionArea.some(function (pos) { return pos.id === position.id; });
        })
            .map(function (_a) {
            var _b = __read(_a, 1), characterId = _b[0];
            return getCharacterById(characterId);
        });
    };
    var getBresenhamLine = function (start, end) {
        return tilemap_utils_1.Area.getBresenhamLine(start, end, map.tiledMap);
    };
    var getDefaultDuration = function () { return state.spells.duration[spellAction.spellId]; };
    return {
        params: params,
        getActionArea: getActionArea,
        setActionArea: function (actionArea) { _actionArea = actionArea; },
        getBresenhamLine: getBresenhamLine,
        getLauncher: getLauncher,
        getDefaultDuration: getDefaultDuration,
        getSpell: function () {
            var spellId = spellAction.spellId;
            return __assign(__assign({}, staticState.spells[spellId]), common_1.ObjectTyped.entries(state.spells)
                .reduce(function (acc, _a) {
                var _b = __read(_a, 2), variableName = _b[0], variableMap = _b[1];
                acc[variableName] = variableMap[spellId];
                return acc;
            }, {}));
        },
        getHitCharactersAlive: function () {
            return getHitCharacters()
                .filter(function (character) { return common_1.CharacterUtils.isAlive(character.health); });
        },
        getAllCharacterAliveIdList: function () {
            return Object.entries(state.characters.health)
                .filter(function (_a) {
                var _b = __read(_a, 2), characterId = _b[0], health = _b[1];
                return common_1.CharacterUtils.isAlive(health);
            })
                .map(function (_a) {
                var _b = __read(_a, 1), characterId = _b[0];
                return characterId;
            });
        },
        targetPos: spellAction.targetPos,
        isPositionAccessible: function (position) {
            var tileType = tilemap_utils_1.Tile.getTileTypeFromPosition(position, map.tiledMap);
            return tileType === 'default' && !isPositionOccupied(position);
        }
    };
};
exports.createSpellEffectHelper = createSpellEffectHelper;
